import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";

const WhyUseThisToolSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#000",
        py: { xs: 6, md: 8, lg: 10 },
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Container maxWidth="xl">
        {/* Section Title */}
        <Typography
          sx={{
            color: "#fff",
            fontFamily: "'SF Pro Display', 'Inter', sans-serif",
            fontWeight: 600, // Bold
            fontStyle: "normal",
            fontSize: { xs: "2rem", sm: "2.5rem", md: "56px" }, // Exact Figma size on desktop
            lineHeight: { xs: "1.2", md: "70px" }, // Exact Figma line height
            textAlign: "center",
            mb: { xs: 4, md: 6, lg: 8 },
            letterSpacing: "-0.02em",
          }}
        >
          Why Use This Tool?
        </Typography>

        {/* Cards */}
        <Grid container spacing={{ xs: 3, md: 4 }} justifyContent="center">
          {[
            {
              img: "/assets/images/Saves-time.svg",
              alt: "Saves Time",
              text: "Saves time researching a skill",
            },
            {
              img: "/assets/images/Job-interviews.svg",
              alt: "Job Interviews",
              text: "Helps you prep for job interviews",
            },
            {
              img: "/assets/images/Career-direction.svg",
              alt: "Career Direction",
              text: "Career direction based on what you already know",
            },
          ].map((card, i) => (
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              key={i}
              display="flex"
              justifyContent="center"
            >
              <Box
                sx={{
                  width: { xs: "100%", sm: "100%", md: "470.6666px" }, // Exact Figma width
                  height: { xs: "auto", md: "200px" }, // Fixed height for desktop
                  background:
                    "linear-gradient(180deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.02) 100%)",
                  borderRadius: "20px",
                  p: { xs: 3, md: 4 },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    background:
                      "linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.04) 100%)",
                  },
                }}
              >
                {/* Icon */}
                <Box
                  sx={{
                    mb: 2,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "50px", // Figma exact width
                    height: "50px", // Figma exact height
                  }}
                >
                  <img
                    src={card.img}
                    alt={card.alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>

                {/* Text */}
                <Typography
                  sx={{
                    color: "#fff",
                    fontFamily: "'SF Pro Display', 'Inter', sans-serif",
                    fontWeight: 400,
                    fontSize: { xs: "18px", sm: "22px", md: "30px" }, // 30px desktop
                    lineHeight: { xs: "26px", sm: "32px", md: "40px" }, // Figma line-height
                    textAlign: "center",
                  }}
                >
                  {card.text}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhyUseThisToolSection;
